import React, {useState} from 'react'
import Button from '@retracedgmbh/ui-components-lib/Button'
import {useNavigate} from 'react-router-dom'
import * as api from '@api'
import {useAuth} from '@state/auth'

import {useCompaniesToSwitch} from '@state/companies-to-switch'
import useTranslator from '@/hooks/useTranslator'
import {BASE_PATH} from '@constants'

const SideBarAccount = ({me, isImpersonating, isAuditing, isAuditor}) => {
  const navigate = useNavigate()
  const {getTranslation} = useTranslator({page: 'sidebar'})
  const companiesToSwitch = useCompaniesToSwitch(state => state.companiesToSwitch)
  const [switchedToCompaniesList, setSwitchedToCompaniesList] = useState(false)

  const {stopImpersonate, stopAuditing, companySwitch, meReceived, isAdmin} = useAuth(state => ({
    stopImpersonate: state.stopImpersonate,
    stopAuditing: state.stopAuditing,
    companySwitch: state.companySwitch,
    meReceived: state.meReceived,
    isAdmin: state.isAdmin,
  }))

  const handlerStopAuditing = () => {
    stopAuditing()
    api.meGet().then(response => {
      if (response.status === 200) {
        meReceived(response.data)
        navigate('/', {replace: true})
      }
    })
  }

  const handleCompanySelection = async company => {
    companySwitch(companiesToSwitch.find(item => item.companyId == company.key))
    await api.meGet().then(response => {
      if (response.status === 200) {
        meReceived(response.data)
        setSwitchedToCompaniesList(false)
      }
    })
    navigate('/', {replace: true})
  }

  if (!me) return <div></div>

  if (switchedToCompaniesList) {
    return (
      <div>
        <div style={{display: 'flex', alignItems: 'center', padding: '8px', justifyContent: 'space-between'}}>
          {companiesToSwitch.length > 0 && !isAuditing ? (
            <Button onClick={() => setSwitchedToCompaniesList(false)} color="primary">
              {getTranslation('sidebar.account.back')}
            </Button>
          ) : null}
        </div>

        {companiesToSwitch.map(company => (
          <a
            key={company.companyId}
            className="navbar-item tw:font-bold tw:py-1 tw:mt-2 tw:mb-2"
            onClick={() => {
              handleCompanySelection(company)
            }}
          >
            <span className="tw:ml-2 ellipsis" style={{maxWidth: '130px', whiteSpace: 'normal'}}>
              {company.name}
            </span>
          </a>
        ))}
      </div>
    )
  }

  return (
    <div>
      <div style={{display: 'flex', alignItems: 'center', padding: '8px', justifyContent: 'space-between'}}>
        <span>
          <b>{getTranslation('sidebar.account.account')}</b>
        </span>
        {companiesToSwitch.length > 0 && !isAuditing ? (
          <Button onClick={() => setSwitchedToCompaniesList(true)} color="primary">
            {getTranslation('sidebar.account.switchAccount')}
          </Button>
        ) : null}
      </div>

      {!isAuditor && (
        <>
          <a
            className="navbar-item tw:font-bold tw:py-1"
            onClick={() => {
              const url = isAdmin()
                ? `${BASE_PATH.COMPANY_MANAGEMENT}/${me.company.id}/view`
                : isAuditing
                  ? `/auditor/companies/${me.company.id}/view`
                  : `/companies/${'TEST'}/view`
              navigate(url)
              window.location.reload()
            }}
          >
            <figure className="tw:w-24 tw:h-24">
              <img
                className="tw:rounded-full"
                src={`${
                  me?.company?.featuredImageFileUrl ||
                  `${import.meta.env.VITE_CDN_URI}/static/dashboard-service/image-404.jpg`
                }?fit=crop&h=96&w=96${isImpersonating ? '&border=48,55FF0000' : ''}`}
              />
            </figure>

            <span className="tw:ml-2 ellipsis" style={{maxWidth: '130px', whiteSpace: 'normal'}}>
              {me.company?.name}
            </span>
          </a>
        </>
      )}

      {!isAuditor && !isAuditing && (
        <>
          <a
            className="navbar-item tw:font-bold tw:py-1 tw:mt-2 tw:mb-2"
            onClick={() => {
              navigate(isAdmin() ? '/management/profile/edit' : '/profile/view')
            }}
          >
            <figure className="tw:w-16 tw:h-16">
              <img
                className="tw:rounded-full"
                src={`${
                  me?.avatarFileUrl || `${import.meta.env.VITE_CDN_URI}/static/dashboard-service/image-404.jpg`
                }?fit=crop&h=64&w=64&auto=format${isImpersonating ? '&border=48,55FF0000' : ''}`}
              />
            </figure>

            <span className="tw:ml-2">{getTranslation('sidebar.account.myProfile')}</span>
          </a>
          <hr className="navbar-divider tw:my-0 tw:mb-2" />
        </>
      )}

      {isImpersonating || isAuditing ? (
        <>
          {isImpersonating && (
            <a
              className="navbar-item tw:font-bold"
              id="profile-action-end-impersonate"
              onClick={() => {
                stopImpersonate()
                navigate('/management/impersonate', {replace: true})
              }}
            >
              {getTranslation('sidebar.account.endImpersonate')}
            </a>
          )}
          {isAuditing && (
            <a
              className="navbar-item tw:font-bold"
              id="profile-action-end-auditing"
              onClick={() => {
                handlerStopAuditing()
              }}
            >
              {getTranslation('sidebar.account.endAudit')}
            </a>
          )}
        </>
      ) : (
        <a
          className="navbar-item tw:font-bold"
          id="profile-action-logout"
          onClick={() => {
            navigate('/logout')
          }}
        >
          <span className="icon tw:mr-1">
            <i className="fa-light fa-sign-out tw:text-base" />
          </span>
          {getTranslation('sidebar.account.logout')}
        </a>
      )}
    </div>
  )
}

export default SideBarAccount
